import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../components/Modal";
import { Text } from "../../../styles/Common";
import { theme } from "../../../styles/theme";
import { Button } from "../../../components/Button";
import { ConfettiIcon } from "../../../assets/icons";
import { useQueryClient } from "react-query";

const ModalSuccess = ({ showModal, handleCloseModal, isMobile }) => {
  const queryClient = useQueryClient();

  const handleContinue = () => {
    handleCloseModal();
    queryClient.invalidateQueries(["getValidateIsFilledProfile"]);
  };

  return (
    <Modal
      open={showModal}
      onCancel={handleCloseModal}
      padding={!isMobile ? "29px 63px 37px 63px" : "29px 25px 37px 25px"}
      width={!isMobile ? "611px" : "100%"}
      height={"auto"}
    >
      <Modal.Header
        title={"¡Felicidades!"}
        sizeTitle={theme.fonts.size.h1}
        colorTitle={theme.colors.blue500}
        weightTitle={theme.fonts.weight.bold}
        margin={"0 0 22px 0"}
        icon={<ConfettiIcon stroke={theme.colors.green300} />}
        iconBackground={theme.colors.white300}
      />
      <Modal.Body>
        <Text
          size={theme.fonts.size.h6}
          color={theme.colors.gray200}
          weight={theme.fonts.weight.semibold}
          mb="40px"
        >
          Ya eres parte de nuestra comunidad. Para incrementar las
          probabilidades de recibir la{" "}
          <span style={{ color: theme.colors.red }}>Pulpeybox</span>, por favor
          responde las siguientes preguntas.
        </Text>

        <Button width={!isMobile ? "297px" : "230px"} onClick={handleContinue}>
          Continuar con las preguntas
        </Button>
      </Modal.Body>
    </Modal>
  );
};
ModalSuccess.propTypes = {
  showModal: PropTypes.bool,
  isMobile: PropTypes.isMobile,
  handleCloseModal: PropTypes.func,
};
export default ModalSuccess;
